<template>
  <v-container fluid grid-list-lg>
    <v-layout row wrap>
      <v-flex xs12 sm8 offset-sm2 pt-5>

        <v-alert :value="true"  v-if="error != null" type="error" >{{ error.message }}</v-alert>
        <v-alert :value="true"  v-if="success != null" type="success" >{{ success.message }}</v-alert>

        <v-layout justify-center column>
          <template v-if="ready">
            <v-form ref="form" v-model="valid" lazy-validation @submit="updateUser" >

              <h2 class="heading-2 align-left">Please select your preferences for official club and partner communications</h2>

              <div class="body-copy">
                <p>Select channels to receive official communications from Warrington Wolves  :</p>
              </div>

              <v-layout row class="border-bottom">
                <v-flex xs12>
                  <v-switch
                  :label="`Email`"
                  v-model="clubEmail"
                  ></v-switch>
                </v-flex>
              </v-layout>

              <v-layout row class="border-bottom">
                <v-flex xs12>
                  <v-switch
                  :label="`SMS`"
                  v-model="clubSMS"
                  ></v-switch>
                </v-flex>
              </v-layout>

              <v-layout row class="border-bottom">
                <v-flex xs12>
                  <v-switch
                  :label="`Phone`"
                  v-model="clubPhone"
                  ></v-switch>
                </v-flex>
              </v-layout>

              <v-layout row class="border-bottom">
                <v-flex xs12>
                  <v-switch
                  :label="`Direct Mail`"
                  v-model="clubDirect"
                  ></v-switch>
                </v-flex>
              </v-layout>

              <div class="body-copy mt-5">
                <p>Select channels to receive communications from Official Club Partners:</p>
              </div>

              <v-layout row class="border-bottom">
                <v-flex xs12>
                  <v-switch
                  :label="`Email`"
                  v-model="partnerEmail"
                  ></v-switch>
                </v-flex>
              </v-layout>

              <v-layout row class="border-bottom">
                <v-flex xs12>
                  <v-switch
                  :label="`SMS`"
                  v-model="partnerSMS"
                  ></v-switch>
                </v-flex>
              </v-layout>

              <v-layout row class="border-bottom">
                <v-flex xs12>
                  <v-switch
                  :label="`Phone`"
                  v-model="partnerPhone"
                  ></v-switch>
                </v-flex>
              </v-layout>

              <v-layout row class="border-bottom">
                <v-flex xs12>
                  <v-switch
                  :label="`Direct Mail`"
                  v-model="partnerDirect"
                  ></v-switch>
                </v-flex>
              </v-layout>

              <v-layout row align-center mx-1 mt-5>
                <v-spacer />
                <button type="submit" class="button" :disabled="!valid || !ready">Update</button>
              </v-layout>

            </v-form>
          </template>

          <template v-else>
            <div class="text-xs-center">
              <v-progress-circular
              :size="50"
              color="accent"
              indeterminate
              ></v-progress-circular>
            </div>
          </template>
        </v-layout>

      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
import axios from 'axios'
export default {
  name: 'UserProfileContactPrefs',
  data () {
    
    return {
      ready: false,
      valid: true,
      clubEmail: false,
      clubSMS: false,
      clubPhone: false,
      clubDirect: false,
      partnerEmail: false,
      partnerSMS: false,
      partnerPhone: false,
      partnerDirect: false,
      error: null,
      success: null,
      loading: false
    }
  },
  created () {
    // load this user's latest information
    this.$getCurrentUserAttributes().subscribe((userData) => {
       
        this.clubEmail = ((userData['custom:club_email'] == "true" ) ? true : false )
        this.clubSMS = ((userData['custom:club_sms'] == "true" ) ? true : false )
        this.clubPhone = ((userData['custom:club_phone'] == "true" ) ? true : false )
        this.clubDirect = ((userData['custom:club_direct'] == "true" ) ? true : false )
        this.partnerEmail = ((userData['custom:partner_email'] == "true" ) ? true : false )
        this.partnerSMS = ((userData['custom:partner_sms'] == "true" ) ? true : false )
        this.partnerPhone = ((userData['custom:partner_phone'] == "true" ) ? true : false )
        this.partnerDirect = ((userData['custom:partner_direct'] == "true" ) ? true : false )
        // tell the app that we've finished loading
        this.ready = true

    }, 
    (err)=> {
        console.log('Unable to load user profile, session may not be present.')
    });
    
  },
  methods: {
    updateUser (e) {
        e.preventDefault()
        this.ready = false
        
        var clubEmail = this.clubEmail.toString();
        var clubSMS = this.clubSMS.toString();
        var clubPhone = this.clubPhone.toString();
        var clubDirect = this.clubDirect.toString();
        var partnerEmail = this.partnerEmail.toString();
        var partnerSMS = this.partnerSMS.toString();
        var partnerPhone = this.partnerPhone.toString();
        var partnerDirect = this.partnerDirect.toString();
        
        var attributesList = {
            "custom:club_email": clubEmail, 
            "custom:club_sms": clubSMS, 
            "custom:club_phone": clubPhone, 
            "custom:club_direct": clubDirect, 
            "custom:partner_email": partnerEmail,
            "custom:partner_sms": partnerSMS,
            "custom:partner_phone": partnerPhone,
            "custom:partner_direct": partnerDirect
        }
       
        this.$updateAttributes(attributesList).subscribe((response) => {
          console.log("update successful")
          this.error = null
          this.success = response
          this.ready = true

        }, 
        (err)=> {
            //if we get an UnkownError it is more than likely because the user has a status of 'FORCE_CHANGE_PASSWORD' in AWS Cognito
            console.log(err.message)
            this.success = null
            this.error = err
            this.ready = true
        });    
    }
  }
}
</script>

<style scoped>
  .border-bottom {
    border-bottom: 1px solid #EEEEEE;
  }
</style>